import { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { encryptData } from "../Services/encryptData";
import { Base64 } from "js-base64";
import { getBearerToken, login } from "../Services/dashboardAction";
import './Login.css';

export default function Login() {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [remember, setRemember] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const dispatch = useDispatch();
   const nav = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (user === "" || pass === "") {
      setErrorMsg("Please fill required fields");
      return;
    }

    const load = { email: user, password: pass };
    const encryptedData = encryptData(load);

    dispatch(getBearerToken(encryptedData)).then((resToken) => {
      const load2 = {
        userCode: user,
        passWord: Base64.encode(pass),
      };
      const encryptedData2 = encryptData(load2);

      dispatch(login(encryptedData2)).then((res) => {
      

        // Save login data
        localStorage.setItem("rolecode", res.user.email);
        localStorage.setItem("token", resToken?.access_token);
        localStorage.setItem("userData", JSON.stringify(res.user));
        localStorage.setItem("loggedIn", "true");

         nav('/promodashboard');
      }).catch((err) => {
        setErrorMsg(err?.response?.data?.details?.[0] || "Login failed");
      });

    }).catch(() => {
      setErrorMsg("Token retrieval failed");
    });
  };

  return (
    <div className="login-container flex h-screen bg-gradient-to-br from-blue-300 to-pink-200 items-center justify-center">
      <div className="form-card w-full max-w-md p-8 bg-white bg-opacity-80 backdrop-blur rounded-2xl shadow-2xl flex flex-col justify-between">
        <div className="flex items-center space-x-2 mb-6">
          <span className="text-3xl font-bold text-teal-600">CureBay</span>
        </div>

        <div>
          <h2 className="text-3xl font-semibold mb-4 text-gray-800">Member Login</h2>

          {errorMsg && (
            <div className="text-red-500 text-sm mb-2">
              {errorMsg}
            </div>
          )}

          <div className="mb-4 relative">
            <span className="p-input-icon-left w-full block">
              <i className="pi pi-user ml-2" />
              <InputText
                placeholder="Email or Username"
                value={user}
                onChange={e => setUser(e.target.value)}
                className="w-full h-12 px-10 rounded-lg bg-white border border-gray-200"
              />
            </span>
          </div>

          <div className="mb-2 relative">
            <span className="p-input-icon-left w-full block">
              <i className="pi pi-lock ml-2" />
              <InputText
                placeholder="Password"
                type="password"
                value={pass}
                onChange={e => setPass(e.target.value)}
                className="w-full h-12 px-10 rounded-lg bg-white border border-gray-200"
              />
            </span>
          </div>
{/* 
          <div className="flex items-center justify-between text-sm mb-6">
            <div className="flex items-center">
              <Checkbox
                inputId="remember"
                checked={remember}
                onChange={e => setRemember(e.checked)}
              />
              <label htmlFor="remember" className="ml-2 text-gray-700">Remember Password</label>
            </div>
            <button className="text-teal-600 hover:underline">Forgot Password?</button>
          </div> */}

          <Button
            label="Login"
            onClick={handleSubmit}
            className="w-full h-12 bg-teal-600 hover:bg-teal-700 text-white rounded-lg mb-4 mt-10"
          />
        </div>
      </div>
    </div>
  );
}
